import { Component, Input } from '@angular/core';
import { AbstractAuditDto, AuditModificationDto } from '../../../service/dto';

@Component({
  selector: 'app-audit-timeline-modification',
  standalone: false,
  templateUrl: './audit-timeline-modification.component.html',
  styleUrl: './audit-timeline-modification.component.scss'
})
export class AuditTimelineModificationComponent {
	list!: AuditModificationDto[];

	@Input()
	set audits(input: AbstractAuditDto[]){
		this.list = input.map(item => item as AuditModificationDto);
	}
}
